import ReactDOM from 'react-dom';
import { jsx as _jsx } from "react/jsx-runtime";
export class AtMentionNodeView {
  constructor(node, view, getPos, options) {
    this.node = node;
    this.view = view;
    this.getPos = getPos;
    this.options = options;
    const styledWrapper = document.createElement('span');
    styledWrapper.setAttribute('data-mention-id', this.node.attrs.id);
    styledWrapper.setAttribute('data-mention-name', this.node.attrs.name);
    if (this.node.attrs.display) {
      styledWrapper.setAttribute('data-mention-display', this.node.attrs.display);
    }
    styledWrapper.setAttribute('data-atmention-text-wrapper', 'true');
    styledWrapper.style.color = 'var(--trellis-color-text-core-default)';
    styledWrapper.style.fontWeight = '600';
    this.dom = styledWrapper;
    this.render();
  }
  render() {
    const Component = this.options.component;
    setTimeout(() => {
      ReactDOM.render( /*#__PURE__*/_jsx(Component, {
        node: this.node,
        view: this.view,
        getPos: this.getPos,
        onAtMentionClick: this.options.onAtMentionClick
      }), this.dom);
    }, 0);
  }
  update(node) {
    if (node.type !== this.node.type) return false;
    this.node = node;
    this.render();
    return true;
  }
  destroy() {
    ReactDOM.unmountComponentAtNode(this.dom);
  }
}